/* Info component on the SceneCreateForm */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";

const InfoCreate = () => {
  return (
    <div>
      <Row className="mb-3">
        <Col className="d-none d-md-block" md={2}></Col>
        <Col xs={12} md={8}>
          <div className={`text-center px-3 py-2 ${styles.SubTitle6}`}>
            <p className={`${styles.Red} text-center`}>INFO</p>
            <hr className={`mt-2 mb-0`}/>
            <p className={`pt-1`}>
              <span className={`${styles.Red}`}>*</span> Create Episodes here to begin the Platform workflow 
              for <span className={`${styles.Red}`}>TV Series</span> production.
            </p>
            <p className={`pt-1`}>
              <span className={`${styles.Red}`}>*</span> Click on each Episode to go to its <span className={`${styles.Red}`}>Scenes Workspace</span>.
            </p>
            <p className={`pt-1 ${styles.Small}`}>
              Note: Episodes cannot be deleted and Episode Numbers cannot be changed.
            </p>
            <hr className={`mt-2 mb-0`}/>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InfoCreate;
